export const NuxtApollo = {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge": 3600, "secure": true, "sameSite": "lax"},
 clients: {"default": {"httpEndpoint": "https://staging-livebouldercreek.kinsta.cloud/wp/graphql", "connectToDevTools": true, "tokenName": "apollo:bcn.token", "authType": "Bearer", "authHeader": "Authorization", "tokenStorage": "cookie", "defaultOptions": undefined}}
}